<template>
  <div class="performer-qualities">
    <h4>Накопленные качества в проектах</h4>
    <div v-if="!isLoading" class="qualities-list">
      <span
        v-for="(quality, index) in qualities"
        :key="index"
        class="quality-tag"
      >
        #{{ quality.name }} <span class="count">({{ quality.count }})</span>
      </span>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { useApi } from '@/api/use-api';

  const api = useApi();
  const isLoading = ref(true);
  const qualities = ref([]);

  onMounted(async () => {
    await fetchQualities();
    isLoading.value = false;
  });

  const fetchQualities = async () => {
    try {
      const response = await api.projectExecutorQuality.userQualities();
      qualities.value = response.qualities.map((item) => ({
        name: item.name,
        count: item.count,
      }));
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
    }
  };
</script>

<style scoped lang="scss">
  .performer-qualities {
    padding: 20px;
    background-color: #f2f4f8;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;

    h4 {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #333;
    }

    .qualities-list {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;

      .quality-tag {
        background-color: #ffffff;
        border-radius: 15px;
        padding: 5px 10px;
        font-size: 14px;
        color: #333;
        display: flex;
        align-items: center;

        .count {
          font-size: 12px;
          color: #666;
          margin-left: 5px;
        }
      }
    }
  }
</style>
